(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.DOMParser || !window.fetch || !window.history || !window.history.pushState) return;

  var mainSelector = '#content';
  var isNavigating = false;
  var currentController = null;
  var excludedPathPrefixes = [
    '/cart',
    '/checkout',
    '/account',
    '/products',
    '/challenge',
    '/apps'
  ];

  function sameOrigin(url) {
    return url.origin === window.location.origin;
  }

  function normalizedPath(url) {
    return url.pathname.replace(/\/+$/, '') || '/';
  }

  function shouldSkipUrl(url) {
    if (!sameOrigin(url)) return true;
    if (url.hash && normalizedPath(url) === normalizedPath(window.location)) return true;
    if (url.searchParams.has('view') || url.searchParams.has('section_id')) return true;
    if (normalizedPath(url) === '/') return true;
    return excludedPathPrefixes.some(function (prefix) {
      return normalizedPath(url) === prefix || normalizedPath(url).indexOf(prefix + '/') === 0;
    });
  }

  function shouldSkipLink(link, event) {
    if (!link || !link.href) return true;
    if (event.defaultPrevented || event.button !== 0) return true;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true;
    if (link.target && link.target !== '_self') return true;
    if (link.hasAttribute('download')) return true;
    if (link.closest('form')) return true;
    if (link.dataset.noSpa === 'true') return true;
    return shouldSkipUrl(new URL(link.href, window.location.href));
  }

  function unloadCurrentSections(container) {
    if (!window.theme || !theme.Sections || typeof theme.Sections.sectionUnload !== 'function') return;
    container.querySelectorAll('[data-section-type]').forEach(function (section) {
      if (typeof theme.Sections._sectionForTarget === 'function' && !theme.Sections._sectionForTarget(section)) return;
      theme.Sections.sectionUnload(section);
    });
  }

  function loadNewSections(container) {
    if (!window.theme || !theme.Sections || typeof theme.Sections.sectionLoad !== 'function') return;
    container.querySelectorAll('[data-section-type]').forEach(function (section) {
      if (typeof theme.Sections._sectionForTarget === 'function' && !theme.Sections._sectionForTarget(section)) return;
      theme.Sections.sectionLoad(section);
    });
  }

  function runInlineScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      if (oldScript.src) return;
      if (oldScript.type && oldScript.type !== 'text/javascript' && oldScript.type !== 'application/javascript') return;
      var newScript = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.text = oldScript.text;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function renderLoadingSkeleton(container) {
    var skeleton = document.createElement('div');
    skeleton.className = 'spa-loading-skeleton';
    skeleton.setAttribute('aria-hidden', 'true');
    unloadCurrentSections(container);
    container.replaceChildren(skeleton);
  }

  function updateBody(nextDocument, keepAssistantOpen) {
    document.body.className = nextDocument.body.className;
    if (keepAssistantOpen) document.body.classList.add('ai-assistant-open');
  }

  function updateHeaderActiveLinks(url) {
    document.querySelectorAll('.section-header .navigation__item--active').forEach(function (item) {
      item.classList.remove('navigation__item--active');
    });
    document.querySelectorAll('.section-header a[aria-current]').forEach(function (link) {
      link.removeAttribute('aria-current');
    });

    document.querySelectorAll('.section-header a[href]').forEach(function (link) {
      var linkUrl = new URL(link.href, window.location.href);
      if (!sameOrigin(linkUrl) || normalizedPath(linkUrl) !== normalizedPath(url)) return;

      link.setAttribute('aria-current', 'page');
      var item = link.closest('.navigation__item');
      if (item) item.classList.add('navigation__item--active');
    });
  }

  function announceNavigation() {
    document.dispatchEvent(new CustomEvent('theme:spa:navigation', { bubbles: true }));
    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('scroll'));
  }

  async function navigateTo(url, options) {
    if (isNavigating) return;

    if (shouldSkipUrl(url)) {
      window.location.href = url.href;
      return;
    }

    var currentMain = document.querySelector(mainSelector);
    if (!currentMain) {
      window.location.href = url.href;
      return;
    }

    isNavigating = true;
    var keepAssistantOpen = document.body.classList.contains('ai-assistant-open') && window.matchMedia('(min-width: 768px)').matches;
    document.documentElement.classList.add('spa-loading');
    currentMain.setAttribute('aria-busy', 'true');
    renderLoadingSkeleton(currentMain);

    if (currentController) currentController.abort();
    currentController = new AbortController();

    try {
      var response = await fetch(url.href, {
        signal: currentController.signal,
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error('Navigation request failed');

      var html = await response.text();
      var nextDocument = new DOMParser().parseFromString(html, 'text/html');
      var nextMain = nextDocument.querySelector(mainSelector);

      if (!nextMain) throw new Error('Missing page content');

      nextMain.setAttribute('aria-busy', 'false');
      currentMain.replaceWith(nextMain);
      updateBody(nextDocument, keepAssistantOpen);
      document.title = nextDocument.title;
      runInlineScripts(nextMain);
      loadNewSections(nextMain);
      updateHeaderActiveLinks(url);

      if (!options || !options.replace) {
        window.history.pushState({ spa: true }, nextDocument.title, url.href);
      } else {
        window.history.replaceState({ spa: true }, nextDocument.title, url.href);
      }

      if (!options || options.scroll !== false) {
        window.scrollTo(0, 0);
      }

      announceNavigation();
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.location.href = url.href;
      }
    } finally {
      isNavigating = false;
      document.documentElement.classList.remove('spa-loading');
      var activeMain = document.querySelector(mainSelector);
      if (activeMain) activeMain.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (shouldSkipLink(link, event)) return;
    event.preventDefault();
    navigateTo(new URL(link.href, window.location.href));
  });

  window.addEventListener('popstate', function () {
    navigateTo(new URL(window.location.href), { replace: true, scroll: false });
  });

  window.history.replaceState({ spa: true }, document.title, window.location.href);
})();
